import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-peijianguanli",
  "use": "icon-peijianguanli-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-peijianguanli\"><path fill=\"#333333\" d=\"M716.8 512v358.4H153.6V307.2h360.96a216.576 216.576 0 0 1-2.56-25.6 224.768 224.768 0 0 1 14.336-76.8H153.6a102.4 102.4 0 0 0-102.4 102.4v563.2a102.4 102.4 0 0 0 102.4 102.4h563.2a102.4 102.4 0 0 0 102.4-102.4V497.664a224.768 224.768 0 0 1-76.8 14.336 216.576 216.576 0 0 1-25.6 0z m51.2-358.4a102.4 102.4 0 1 0 102.4 102.4 102.4 102.4 0 0 0-102.4-102.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/peijianguanli.svg
// module id = 01py
// module chunks = 16